import * as React from "react";
import { OptionField, OptionCardGroup, Input } from "@aisquare/ui";
import { Sparkles, FileText, Mic } from "lucide-react";
import { Section, VariantBlock } from "../lib/Section";

export function OptionFieldDemo() {
  const [format, setFormat] = React.useState("quest");

  return (
    <Section
      id="option-field"
      title="OptionField"
      description="The configurable-field building blocks for the experience config / create surfaces. OptionField wraps any control in a labelled row (label + optional required mark + a helper line that flips to an error message). OptionCardGroup is the selectable option-card pattern built on Radix RadioGroup, so single-select semantics, roving focus, and the radiogroup/radio roles come for free — the whole card is the click target and the checked card reads in primary."
    >
      <VariantBlock label="OptionField — helper + error" caption="the helper line flips to a destructive error message when error is set">
        <div className="flex w-full max-w-md flex-col gap-5">
          <OptionField label="Experience name" htmlFor="name" required helper="Shown on the experience card.">
            <Input id="name" defaultValue="Intro to Calculus" />
          </OptionField>
          <OptionField label="Slug" htmlFor="slug" error="This slug is already taken.">
            <Input id="slug" defaultValue="intro-to-calculus" />
          </OptionField>
        </div>
      </VariantBlock>

      <VariantBlock label="OptionCardGroup" caption="single-select option cards — the checked card reads in primary">
        <div className="w-full max-w-md">
          <OptionField label="Format" helper="Pick how this experience is delivered.">
            <OptionCardGroup
              value={format}
              onValueChange={setFormat}
              options={[
                { value: "quest", label: "Quest", description: "A guided, multi-step course", icon: <Sparkles /> },
                { value: "note", label: "AI Note", description: "A single rich document", icon: <FileText /> },
                { value: "podcast", label: "Podcast", description: "A generated audio episode", icon: <Mic /> },
              ]}
            />
          </OptionField>
        </div>
      </VariantBlock>

      <VariantBlock label="Two-column cards" caption="columns={2} lays the cards out in a responsive grid">
        <div className="w-full max-w-md">
          <OptionCardGroup
            defaultValue="public"
            columns={2}
            options={[
              { value: "public", label: "Public", description: "Anyone can view" },
              { value: "team", label: "Team", description: "Your workspace only" },
              { value: "private", label: "Private", description: "Only you" },
              { value: "link", label: "Link", description: "Anyone with the link", disabled: true },
            ]}
          />
        </div>
      </VariantBlock>
    </Section>
  );
}
